module.exports = __webpack_public_path__ + "img/a3.b417d08d.png";